import React, { createRef, Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Form, Control } from 'react-redux-form';
import { Row, Col, OverlayTrigger, Popover } from 'react-bootstrap';
import Translation from '../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation, EQUIPMENT_TYPE as EquipmentType, CIRCUIT_TYPES as CircuitTypes } from '../../../../../../utils/constant.utils';
import {
    OR_RRF_Select as Select
    , ORFButton as Button
    , ORFSelect
    , ORFField
} from '../../../../../common/forms/order-request-form.component';
import { newMobileSubscriptionActions } from "./../../../../../../store/external/request-reducer/order-request-reducer/wireless-request/new-mobile-subscription.reducer";
import { CheckBox } from '../../../../../common/custom-form/checkbox.component';
import TableWithButton from '../../../../../common/details-table/table-with-button.component';
import { ControlCheckBox } from '../../../../../common/custom-form/checkbox.component';
import CustomSearchableSelectWrapper from '../../../../../common/custom-form/custom-searchable-select-wrapper.component';
import { MAX_LENGTH } from '../../../../../../constants/external-constants';
import { addZeroes } from '../../../../../../../../src/app/store/external/request-reducer/order-request.functions';
import ModalContainer from '../../../../../common/modal/modal-container/modal-container.component';
import CheckoutForm from '../../../../../common/stripe/checkout-form';
import PaymentDetails from '../../../../../common/stripe/payments-details';
import CreateVirtualCardForm from '../../../../../common/stripe/create-virtual-card';
import CustomSearchableDropdownWrapper from '../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper';
import { ChatbotActions } from "./../../../../../../store/common/chatbot/chatbot.reducer";
import { httpGet } from '../../../../../../utils/api.utils';

class WirelessSubscriptionFormA extends Component {
    constructor(props) {
        super(props);
        this.state = {
            serviceTypeExist: false,
            serviceTypeExistOnprogress: false,
            isDevice: false,
            showModalForm: false,
            paymentMethod: null,
            userData: null,
            cachedDeviceOptions: [],
            isKyberProcAuthorized: false,
            isKyberProcAuthorizationLoaded: false
        }
    }

    componentDidMount() {
        this.props.onSubscriptionFormLoad();
        this.props.fetchNewMobileOptions();
        this.loadKyberProcAuthorization();
    }

    componentDidUpdate(prevProps) {
        const { wirelessSubscriptionFormA } = this.props;

        const newMobileRequest = this.props.newMobileRequest || {};
        const employeeEquipmentProductNames = newMobileRequest.employeeEquipmentProductNames || [];
        const employeeEquipmentOnprogressProductNames = newMobileRequest.employeeEquipmentOnprogressProductNames || [];

        const prevDeviceOptions = prevProps?.newMobileRequest?.deviceOptions || [];
        const currDeviceOptions = this.props?.newMobileRequest?.deviceOptions || [];

        if (currDeviceOptions !== prevDeviceOptions && Array.isArray(currDeviceOptions) && currDeviceOptions.length >= 2) {
            this.setState({ cachedDeviceOptions: currDeviceOptions });
        }

        if (wirelessSubscriptionFormA.mobileServiceModel !== prevProps.wirelessSubscriptionFormA.mobileServiceModel) {
            const mobileServiceModel = wirelessSubscriptionFormA.mobileServiceModel || [];

            const productNamesFilter = employeeEquipmentProductNames.filter(name => name);
            const productNames = productNamesFilter.includes(
                mobileServiceModel.length > 0 &&
                mobileServiceModel[0].EquipmentProductName
            );

            this.setState({ serviceTypeExist: productNames });

            const onProgressProductNameFilter = employeeEquipmentOnprogressProductNames.filter(name => name);
            const onProgressProductNames = onProgressProductNameFilter.includes(
                mobileServiceModel.length &&
                mobileServiceModel[0].EquipmentProductName
            );

            this.setState({ serviceTypeExistOnprogress: onProgressProductNames });

            const device = (mobileServiceModel.length > 0 ?
                mobileServiceModel[0].EquipmentTypeId === EquipmentType.Device : false
            );

            this.setState({ isDevice: device });
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    renderPopover = (title, body) => {
        return (
            <Popover id="comp-popover" title={title} className="plan-comp-popover">
                {body}
            </Popover>
        );
    };

    handlePrevAction = () => {
        this.props.disableAutoScroll(true);
        this.props.prevAction();
    }

    handlePaymentModal = () => {
        this.setState({ showModalForm: true })
    }

    handleCloseFormModal = () => {
        this.setState({ showModalForm: false })
    }

    handleGetPaymentID = (paymentData) => {
        this.setState({ paymentMethod: paymentData })
    }


    handelClearPaymentMethod = () => {
        this.setState({ paymentMethod: null })
    }


    handleNextAction = () => {
        const { paymentMethod } = this.state;
        this.props.nextAction();
        if (this.props.handlePaymentID) {
            this.props.handlePaymentID(paymentMethod)
        }

    }

    handleGetCustomerInformation = (userData) => {
        this.setState({ userData: userData })
    }

    findOptionValue = (options, key) => {
        if (!options || !Array.isArray(options)) return "";
        const k = key?.toString?.() ?? `${key}`;
        const match = options.find(o => (o?.Key?.toString?.() ?? `${o?.Key}`) === k);
        return match?.Value ?? "";
    };

    openAskAi = async (payload) => {
        if (!this.canUseKyberProcAskAi()) {
            return;
        }
        const entrySource = payload?.entrySource || "plan_link";
        const isDevice = entrySource === "service_type_link";
        const contextType = isDevice ? "device_advisor" : "plan_advisor";
        const startMsg = isDevice ? "DEVICE_ADVISOR_START" : "PLAN_ADVISOR_START";

        await this.props.setContext(contextType, payload, entrySource);
        this.props.toggleChat(true);
        await this.props.sendMessage(startMsg, 0, 0, false, 0, false);
    };

    loadKyberProcAuthorization = async () => {
        try {
            const result =
                await httpGet(
                    'external/kyberconfig/kyber-proc-agent/enabled'
                );

            if (
                result == null ||
                result?.ok === false
            ) {
                throw new Error(
                    'Unable to retrieve KyberProc authorization.'
                );
            }

            const isAuthorized =
                result?.isEnabled === true ||
                result?.IsEnabled === true;

            this.setState({
                isKyberProcAuthorized: isAuthorized,
                isKyberProcAuthorizationLoaded: true,
            });

            return isAuthorized;
        } catch (error) {
            console.error(
                'KyberProc authorization check failed:',
                error
            );

            this.setState({
                isKyberProcAuthorized: false,
                isKyberProcAuthorizationLoaded: true,
            });

            return false;
        }
    };

    canUseKyberProcAskAi = () =>
        this.state.isKyberProcAuthorizationLoaded === true &&
        this.state.isKyberProcAuthorized === true;

    render() {

        const {
            // component props
            onClickCancel
            , prevAction
            , nextAction
            // form
            , wirelessSubscriptionFormA

            // reducer action
            , onVendorSelect
            , onPlanSelect
            , onCircuitTypeSelect
            , onServiceTypeSelect

            , handleMobServiceTypeSearch
            , loadMoreMobServiceType
            , handlePlanTypeSearch
            , loadMorePlanType
            , handleVendorSearch
            , loadMoreVendor
            , loadMoreCircuitType
            , handleCircuitTypeSearch
        } = this.props;

        const { paymentMethod } = this.state;

        const { planOptions
            , simOptions
            , preferredVendorOptions
            , orderOptions
            , deviceOptions
            , deviceAccessories
            , vendorDetails
            , circuitTypes
            , serviceTypeDetail
            , primaryPlanDetail
            , showDeviceOptions
            , employeeEquipmentProductNames
            , employeeEquipmentOnprogressProductNames

            , hasMoreVendor
            , isVendorLoading
            , vendorOptions

            , isMobServiceTypeLoading
            , hasMoreMobServiceType

            , hasMoreCircuitType
            , isCircuitTypeLoading

            , isPlanTypeLoading
            , hasMorePlanType
            , newMobileRequestOptions } = this.props.newMobileRequest;


        const disable = !wirelessSubscriptionFormA.vendorDetailId ||
            !wirelessSubscriptionFormA.equipmentInventoryId ||
            !wirelessSubscriptionFormA.planId ||
            !wirelessSubscriptionFormA.circuitTypeId;


        const planCost = wirelessSubscriptionFormA.planDetailsModel.length > 0 && wirelessSubscriptionFormA.mobileServiceModel.length > 0 ? wirelessSubscriptionFormA.planDetailsModel[0].dataItem[0].TotalComponentCost : 0;

        const totalOrderCost = wirelessSubscriptionFormA.planId
                         ? (wirelessSubscriptionFormA.mobileServiceModel.length > 0 && wirelessSubscriptionFormA.planDetailsModel.length > 0
                            ? wirelessSubscriptionFormA.mobileServiceModel[0].DiscountedOrderCost + planCost
                            : 0)
                         :0;

        const totalOrderCostFormatted = Number(totalOrderCost).toFixed(2);


        if (showDeviceOptions) {
            disable = disable || wirelessSubscriptionFormA.equipmentInventoryId == 0;
        }

         const IsEnabledPaymentInformation = JSON.parse(sessionStorage.getItem('IsEnabledPaymentInformation'));
        const showServiceWarning = this.state.serviceTypeExist === true && this.state.isDevice && (wirelessSubscriptionFormA.equipmentInventoryId != undefined || wirelessSubscriptionFormA.equipmentInventoryId == 0);
        const showExisitingWarning = this.state.serviceTypeExistOnprogress == true && this.state.isDevice && (wirelessSubscriptionFormA.equipmentCatalogId != undefined || wirelessSubscriptionFormA.equipmentCatalogId == 0);
        const showDeviceDiscountedOrderCost = (wirelessSubscriptionFormA.circuitTypeId == CircuitTypes.mobile_or_cellphone || wirelessSubscriptionFormA.circuitTypeId == CircuitTypes.data_card) && wirelessSubscriptionFormA.equipmentInventoryId != undefined && wirelessSubscriptionFormA.equipmentInventoryId != 0;
        return (
            <div >
                <Form method="post" role="form"
                    model="wirelessSubscriptionFormA"
                    onSubmit={this.handleNextAction}
                >
                    {/* <Row>
                        <Col xs={12} md={12} lg={12} className='required'>
                            <Select
                                className="form-control"
                                label={`${this.toLocaleLanguage('request_type')}`}
                                value={wirelessSubscriptionFormA.RequestTypeId}
                                options={newMobileRequestOptions}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.RequestTypeId'
                            />
                        </Col>

                    </Row> */}
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-wrapper-plan custom-margin'>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('vendor')}`}
                                options={vendorOptions}
                                selected={wirelessSubscriptionFormA.vendorDetailId}
                                onChange={(e) => {
                                    onVendorSelect('wirelessSubscriptionFormA.vendorDetailId', e.toString())
                                }}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.vendorDetailId'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}

                                onSearchChange={handleVendorSearch}
                                onLoadMore={loadMoreVendor}
                                isLoading={isVendorLoading}
                                hasMore={hasMoreVendor}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={12} lg={12} className='required custom-wrapper-plan custom-margin'>
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage('circuit_type')}`}
                                options={circuitTypes}
                                selected={wirelessSubscriptionFormA.circuitTypeId}
                                onChange={(val) => onCircuitTypeSelect(val)}
                                placeholder={this.toLocaleLanguage('select_placeholder')}
                                fieldProp='.circuitTypeId'
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{
                                    Key: 'Key',
                                    Value: 'Value'
                                }}

                                onSearchChange={handleCircuitTypeSearch}
                                onLoadMore={loadMoreCircuitType}
                                isLoading={isCircuitTypeLoading}
                                hasMore={hasMoreCircuitType}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col
                            className={`${(
                                this.state.serviceTypeExist == true &&
                                (wirelessSubscriptionFormA.equipmentInventoryId != undefined ||
                                    wirelessSubscriptionFormA.equipmentInventoryId == 0)
                            ) && "service-type-container"} required custom-wrapper-plan custom-margin 
                            ${showServiceWarning || showExisitingWarning || showDeviceDiscountedOrderCost? "custom-margin-2px" : ""}`}
                            xs={12}
                            md={12}
                            lg={12}
                        >
                            <CustomSearchableDropdownWrapper
                                className="form-control"
                                label={`${this.toLocaleLanguage("mobile_service_type")}`}
                                labelRight={
                                    this.canUseKyberProcAskAi() &&
                                        Number(
                                            wirelessSubscriptionFormA
                                                .equipmentInventoryId || 0
                                        ) > 0 ? (
                                        <span
                                            className="ask-ai-inline"
                                            onClick={() => {
                                                const equipmentId = Number(wirelessSubscriptionFormA.equipmentInventoryId || 0);
                                                const equipmentModel =
                                                    equipmentId > 0 ? this.findOptionValue(deviceOptions, equipmentId) : null;

                                                const planId = Number(wirelessSubscriptionFormA.planId || 0);
                                                const planName = planId > 0 ? this.findOptionValue(planOptions, planId) : null;

                                                const currentDeviceOptions = Array.isArray(deviceOptions) ? deviceOptions : [];
                                                const cachedDeviceOptions = Array.isArray(this.state.cachedDeviceOptions)
                                                    ? this.state.cachedDeviceOptions
                                                    : [];

                                                const sourceOptions = currentDeviceOptions.length >= 2 ? currentDeviceOptions : cachedDeviceOptions;

                                                const allowedEquipmentIds = sourceOptions
                                                    .map(o => Number(o?.Key ?? 0))
                                                    .filter(n => Number.isFinite(n) && n > 0);

                                                const payload = {
                                                    entrySource: "service_type_link",
                                                    selectedEquipmentInventoryId: equipmentId,
                                                    selectedEquipmentModel: equipmentModel,
                                                    circuitTypeId: Number(wirelessSubscriptionFormA.circuitTypeId || 0),
                                                    vendorId: Number(wirelessSubscriptionFormA.vendorDetailId || 0),
                                                    allowedEquipmentIds,
                                                    ...(planId > 0 ? { selectedPlanId: planId, selectedPlanName: planName } : {}),
                                                };

                                                if (!allowedEquipmentIds || allowedEquipmentIds.length < 2) {
                                                    console.warn("Ask AI: allowedEquipmentIds has < 2 items. Cannot compare within selection reliably.");
                                                }
                                                this.openAskAi(payload);
                                            }}
                                        >
                                            Ask AI ✨
                                        </span>
                                    ) : null
                                }
                                options={deviceOptions}
                                selected={wirelessSubscriptionFormA.equipmentInventoryId}
                                onChange={(e) => {
                                    onServiceTypeSelect("wirelessSubscriptionFormA.equipmentInventoryId", e);
                                }}
                                placeholder={this.toLocaleLanguage("select_placeholder")}
                                fieldProp=".equipmentInventoryId"
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{ Key: "Key", Value: "Value" }}
                                onSearchChange={handleMobServiceTypeSearch}
                                onLoadMore={loadMoreMobServiceType}
                                isLoading={isMobServiceTypeLoading}
                                hasMore={hasMoreMobServiceType}
                            />

                            {showServiceWarning && (
                                <div>
                                    <span className="warning-label">
                                        {`${this.toLocaleLanguage("warning_service_type")}`}
                                    </span>
                                </div>
                            )}

                            {showExisitingWarning && (
                                <div>
                                    <span className="warning-label">
                                        {`${this.toLocaleLanguage("warning_service_type_existing_open_request")}`}
                                    </span>
                                </div>
                            )}
                        </Col>
                    </Row>

                    {showDeviceDiscountedOrderCost ?
                        <TableWithButton
                        classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub mt-3"
                        datatable={wirelessSubscriptionFormA.mobileDetailsModel}
                        haveExternalDeleteBtn={false}
                        haveCheckBox={false}                    
                        /> : null
                    }

                    {
                        wirelessSubscriptionFormA.circuitTypeId == CircuitTypes.mobile_or_cellphone && wirelessSubscriptionFormA.equipmentInventoryId != undefined && wirelessSubscriptionFormA.equipmentInventoryId != 0 &&
                        <ControlCheckBox
                            classWrapper="custom-checkbox-wrapper"
                            label={`${this.toLocaleLanguage('include_phone_accessory')}`}
                            model="wirelessSubscriptionFormA.phoneCaseAccessory"
                            checked={wirelessSubscriptionFormA.phoneCaseAccessory}
                        />
                    }
                    <Row>
                        <Col xs={12} md={12} lg={12} className="required custom-wrapper-plan">
                            <CustomSearchableDropdownWrapper
                                label={`${this.toLocaleLanguage("plan")}`}
                                labelRight={
                                    this.canUseKyberProcAskAi() &&
                                        Number(
                                            wirelessSubscriptionFormA.planId || 0
                                        ) > 0 ? (
                                        <span
                                            className="ask-ai-inline"
                                            onClick={() => {
                                                const planId = Number(wirelessSubscriptionFormA.planId || 0);
                                                const planName = this.findOptionValue(planOptions, planId);

                                                const equipmentId = Number(wirelessSubscriptionFormA.equipmentInventoryId || 0);
                                                const equipmentModel =
                                                    equipmentId > 0 ? this.findOptionValue(deviceOptions, equipmentId) : null;

                                                const payload = {
                                                    entrySource: "plan_link",
                                                    selectedPlanId: planId,
                                                    selectedPlanName: planName,
                                                    circuitTypeId: Number(wirelessSubscriptionFormA.circuitTypeId || 0),
                                                    vendorId: Number(wirelessSubscriptionFormA.vendorDetailId || 0),
                                                    selectedEquipmentInventoryId: equipmentId,
                                                    selectedEquipmentModel: equipmentModel,
                                                    countryCode: wirelessSubscriptionFormA.countryCode || "",
                                                    currencyUnit: vendorDetails?.Currency || "",
                                                };

                                                this.openAskAi(payload);
                                            }}
                                        >
                                            Ask AI ✨
                                        </span>
                                    ) : null
                                }
                                options={planOptions}
                                selected={Number(wirelessSubscriptionFormA.planId || 0)}
                                onChange={(e) => onPlanSelect(".planId", e)}
                                placeholder={this.toLocaleLanguage("select_placeholder")}
                                fieldProp=".planId"
                                maxLength={MAX_LENGTH.limit_100}
                                optionLabelKey={{ Key: "Key", Value: "Value" }}
                                onSearchChange={handlePlanTypeSearch}
                                onLoadMore={loadMorePlanType}
                                isLoading={isPlanTypeLoading}
                                hasMore={hasMorePlanType}
                            />
                        </Col>
                    </Row>
                    {wirelessSubscriptionFormA.planId ?
                        <TableWithButton
                            classNameWrapper="table-details-wrapper detail-list-modal table-padding-sub"
                            datatable={wirelessSubscriptionFormA.planDetailsModel}
                            haveExternalDeleteBtn={false}
                            haveCheckBox={true}
                        /> : null
                    }

                    <div className="price-plan-total-cost-container">
                        <div className="price-plan-header">
                            <span><Translation translationKey="total_order_cost" /></span>
                        </div>
                        <div className="price-plan-total">
                            <span>{vendorDetails.Currency}</span>
                             <span>{totalOrderCostFormatted}</span>
                        </div>
                    </div>
                    <div className="request-button-continer mb-3">
                       { IsEnabledPaymentInformation ? 
                            <div className="bottom-right">
                                <Button
                                    label={`${paymentMethod ? 'View Payment Information'
                                        : 'Enter Payment Information'}`}
                                    variant={"primary"}
                                    action={this.handlePaymentModal}
                                    type="button"
                                />
                            </div>
                            : null
                        }
                        
                    </div>
                    <div className="request-button-continer">
                        <div className="bottom-left">
                            <Button
                                label={this.toLocaleLanguage('modal_close_cancel_button')}
                                variant={"light"}
                                action={onClickCancel}
                                type="button"
                            />
                        </div>
                        <div className="bottom-right">
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('back')}
                                    variant={"outline-secondary"}
                                    action={this.handlePrevAction}
                                    className="btn-custom-violet-hover-outline"
                                    type="button"
                                />
                            </div>
                            <div>
                                <Button
                                    label={this.toLocaleLanguage('next_button')}
                                    variant={"primary"}
                                    type={"submit"}
                                    disabled={disable}
                                />
                            </div>
                        </div>
                    </div>
                </Form>
                <ModalContainer
                    title="payment_information"
                    show={this.state.showModalForm}
                    handleModal={this.handleCloseFormModal}
                    hideBtn={true}
                    customClass="modal-blur"
                >
                    {
                        paymentMethod ?
                            <PaymentDetails
                                cardholderName={paymentMethod.billing_details.name}
                                cardNumberLast4={paymentMethod.card.last4}
                                cardType={paymentMethod.card.brand}
                                customerEmail={paymentMethod?.billing_details?.email}
                                customerPhone={paymentMethod?.billing_details?.phone}
                                expiryDate={paymentMethod.card.exp_month + ' / ' + paymentMethod.card.exp_year}
                                billingAddress={paymentMethod.billing_details.address.country + ' ' +
                                    paymentMethod.billing_details.address.postal_code + ' ' +
                                    paymentMethod.billing_details.address.line1}
                                enableDeleteBtn={true}
                                onClearPaymentMethod={this.handelClearPaymentMethod}
                            />
                            :
                            <CheckoutForm
                                handleGetPaymentID={this.handleGetPaymentID}
                            />
                    }

                </ModalContainer>
            </div>
        );
    }
};


export default connect(
    state => {
        const { newMobileRequest, translation } = state;
        const { wirelessSubscriptionFormA } = state.form;
        return {
            newMobileRequest
            , wirelessSubscriptionFormA
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newMobileSubscriptionActions, ChatbotActions),
            dispatch
        )
)(WirelessSubscriptionFormA);
